module.exports = "/_next/static/images/23577460cbfcb7cc7780ca467a6768e1-chat-icon.svg.webp";